<script lang="ts" setup>
import AppButton from '~/components/ui/buttons/AppButton.vue'
import loginUser from '~/features/auth/login/login'
import type { ILogin } from '~/shared/interfaces/auth'

const props = defineProps<{
  loginForm: ILogin
}>()

const emits = defineEmits(['pass-response', 'pass-errors'])
const isSubmitting = ref(false)
const loginFormState = ref(false)
const mailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

async function getAuth(loginForm: ILogin) {
  if (isSubmitting.value) return
  isSubmitting.value = true
  const state = checkFormState()

  if (loginFormState.value) {
    try {
      const res = await loginUser(loginForm)
      if (res.status === 409 && res.errors) {
        emits('pass-errors', ['emailDeleted', res.errors[0].message])
      } else {
        emits('pass-response', res)
      }
    } catch (error) {
      console.error('Ошибка авторизации:', error)
      emits('pass-errors', state)
    } finally {
      isSubmitting.value = false
    }
  } else {
    emits('pass-errors', state)
    isSubmitting.value = false
  }
}

function checkFormState() {
  let errors = []
  if (props.loginForm.email) {
    if (!props.loginForm.email.match(mailRegExp)) {
      errors.push('emailFormat')
    }
  } else {
    errors.push('emailEmpty')
  }

  if (!props.loginForm.password) {
    errors.push('passwordEmpty')
  }

  !errors.length
    ? (loginFormState.value = true)
    : (loginFormState.value = false)

  return errors
}
</script>

<template>
  <AppButton
    class="login-btn"
    @click="getAuth(loginForm)"
    :is-disabled="isSubmitting"
    text="Войти"
    size="l"
  />
</template>

<style lang="scss" scoped>
.login-btn {
  width: 100%;
}
</style>
